import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import { quodeTheme } from './quodeTheme';
import { QuodeMark } from './QuodeMark';
import './brand.css';

const quodeThemeExtension = ThemeBlueprint.make({
  name: 'quode',
  params: {
    theme: {
      id: 'quode',
      title: 'Quode Midnight',
      variant: 'dark',
      icon: <QuodeMark size={20} />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={quodeTheme}>
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [quodeThemeExtension],
});
